import React from 'react';
import { useIntl } from 'react-intl';

import { formatAmount } from '@xingternal/pages-common';

import EntityInfo from './EntityInfo';

import { EntityInfoContainerProps } from '../types';


const EntityInfoTopicPage = ({ condensed, headerContent }:  EntityInfoContainerProps) => {
  if (headerContent?.__typename !== "EntityPageTopicPageHeaderContent") {
    return null;
  }
  
  const intl = useIntl();
  let entityInfoData = [];
  const followersTotal = headerContent?.followers?.total;

  if (followersTotal && followersTotal > 0) {
    entityInfoData.push({
      value: formatAmount({ value: followersTotal, intl }),
      label: ` ${intl.formatMessage({
        id: followersTotal > 1 ? 'EP_FOLLOWERS.other' : 'EP_FOLLOWERS.one',
      })}`,
      testId: 'HEADER_FOLLOWERS_TOTAL',
    });
  }

  return <EntityInfo data={entityInfoData} condensed={condensed} />;
};

export default EntityInfoTopicPage;